import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';

/**
 * Lists every user account (only 2 exist — Victor + Jérémy). Used as the
 * picker source when sharing a private entity via useAddMember().
 */
export function useAdminUsers() {
  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: () => api.get('/admin/users'),
    staleTime: 60_000,
  });
}
